<section class="main-section">
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Account Owner</h2>
          <div class="row mt-3">
            <div class="col-md-5">
              <div class="form-group">
                <ng-select id="accountOwner" [(ngModel)]="register.Id" [ngModelOptions]="{standalone: true}" required
                           [items]="accountOwners"
                           bindLabel="ownerName"
                           placeholder="Account Owner"
                           bindValue="id">
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 text-right">
          <button type="reset" class="btn btn-cancel">Cancel</button>
          <button  *ngIf="caller.parent == 'INVENTORY'" (click)="submitAccount()" class="btn btn-orange ml-3">Next</button>
          <button  *ngIf="caller.parent == 'CONTACTS'" (click)="submitAccountOwner()" class="btn btn-orange ml-3">Next</button>
          <button  *ngIf="caller.parent == 'STOCK'" (click)="submitStockAccount()" class="btn btn-orange ml-3">Next</button>
      </div>
    </div>
  </form>
</section>
